import axios from 'axios';
import { ContactUsMessageI } from '../types/logic/ContactUsMessage';

const URL = '/contact-request';

export const sendContactUsMessage = (body: ContactUsMessageI) => {
  return axios.post(`${process.env.REACT_APP_API_URL}${URL}`, body);
};
